module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_1-d85000669a396a8ef4caa7adcbbafa54.svg";